import { ColumnDef } from "@tanstack/react-table";
import { displayCountOrDash } from "@/core/utils/number";

// Interface for rows that have enriched spiff counts
interface WithSpiffCounts {
  yard_sign_photo_count: number;
}

const YardSignsCol = <T extends WithSpiffCounts>(): ColumnDef<T> => ({
  header: "Yard Signs",
  accessorFn: (row) => row.yard_sign_photo_count,
  cell: ({ getValue }) => displayCountOrDash(getValue() as number),
});

export default YardSignsCol;
